import {
    ACCOUNT,
    ACTIVITY,
    ADD_RIGHTS,
    ALL_BOOKS,
    ALERT,
    ARROW_UP,
    AVAILABLE,
    BEAKER,
    BELL,
    BELL_SLASH,
    BOOKSHELF,
    BOOK_COVER,
    CALCULATE,
    CANCEL,
    CHECKMARK,
    CHEVRON,
    CHILD,
    CIRCLE_CHECK,
    CIRCLE_CHECK_OPEN,
    CIRCLE_EXCLAMATION,
    CIRCLE_INFO,
    CIRCLE_PLUS,
    CLOSE,
    COLLEGE,
    COMMENT,
    COMPANY,
    COURSES,
    DENIED,
    DOWNLOAD,
    FULFILLMENT,
    ENVELOPE,
    GEAR,
    HAMBURGER_MENU,
    LARGE_CLOSE,
    LOADER,
    LOCATION,
    NEEDS_ATTENTION,
    NOTE,
    NOT_FOUND,
    OPTIONS,
    PENCIL,
    PENDING,
    PRODUCT_OPTIONS,
    REQUEST,
    REQUESTED,
    REQUEST_RIGHTS,
    RETIRED,
    SEARCH,
    SHARE,
    STATUS_CHANGE,
    SUBSTITUTED,
    TRASH_CAN,
    UNAVAILABLE,
    WATCH,
    WATCHING
} from "@legacy/helpers/constants/sharedStatics";

export default {
    ACCOUNT,
    ACTIVITY,
    ADOPT: ADD_RIGHTS,
    ALERT,
    ALL_BOOKS,
    ARROW_UP,
    AVAILABLE,
    BEAKER,
    BELL,
    BELL_SLASH,
    BOOKSHELF,
    BOOK_COVER,
    CALCULATE,
    CANCEL,
    CHECKMARK,
    CHEVRON,
    CHILD,
    CLOSE,
    CIRCLE_CHECK,
    CIRCLE_CHECK_OPEN,
    CIRCLE_EXCLAMATION,
    CIRCLE_INFO,
    CIRCLE_PLUS,
    COLLEGE,
    COMMENT,
    COMPANY,
    COURSES,
    DENIED,
    DOWNLOAD,
    ENVELOPE,
    FULFILLMENT,
    GEAR,
    HAMBURGER_MENU,
    LARGE_CLOSE,
    LOADER,
    LOCATION,
    NEEDS_ATTENTION,
    NOT_FOUND,
    NOTE,
    OPTIONS,
    PENCIL,
    PENDING,
    PRODUCT_OPTIONS,
    REQUEST,
    REQUEST_RIGHTS,
    RETIRED,
    SEARCH,
    SHARE,
    STATUS_CHANGE,
    SUBMITTED: REQUESTED,
    SUBSTITUTED,
    TRASH_CAN,
    UNAVAILABLE,
    WATCH,
    WATCHING
};
